var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{on:{"change":_vm.changeSelect},model:{value:(_vm.myselected),callback:function ($$v) {_vm.myselected=$$v},expression:"myselected"}},_vm._l((_vm.myoptions),function(item){return _c('el-option',{key:item.vid,attrs:{"label":item.name,"value":item.vid}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }